import React from "react";
import { Helmet } from "react-helmet";

const GujaratSEO = () => {
  return (
    <Helmet>
      {/* 🟢 BASIC META */}
      <title>
        Buy Sex Toys in Gujarat | Discreet Delivery in Ahmedabad, Surat, Vadodara
      </title>

      <meta
        name="description"
        content="Buy sex toys online in Gujarat with 100% discreet delivery. Trusted adult store delivering to Ahmedabad, Surat, Vadodara, Rajkot & Gandhinagar. Products for men, women & couples."
      />

      <meta
        name="keywords"
        content="sex toys in Gujarat, buy sex toys Ahmedabad, sex toys Surat, adult toys Vadodara, sex toys Rajkot, sex toys Gandhinagar, adult store Gujarat, sex toys for men women couples"
      />

      <meta name="robots" content="index, follow" />

      {/* 🟢 CANONICAL */}
      <link
        rel="canonical"
        href="https://lushdesire.in/sex-toys-in-gujarat"
      />

      {/* 🟢 OPEN GRAPH (FACEBOOK / WHATSAPP) */}
      <meta property="og:type" content="website" />
      <meta
        property="og:title"
        content="Buy Sex Toys in Gujarat | 100% Discreet Delivery"
      />
      <meta
        property="og:description"
        content="Order premium sex toys in Gujarat with fast & private delivery. Serving Ahmedabad, Surat, Vadodara, Rajkot & more."
      />
      <meta
        property="og:url"
        content="https://lushdesire.in/sex-toys-in-gujarat"
      />
      <meta
        property="og:image"
        content="https://lushdesire.in/assets/og-gujarat.jpg"
      />

      {/* 🟢 TWITTER */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content="Sex Toys Delivery in Gujarat | LushDesire"
      />
      <meta
        name="twitter:description"
        content="Discreet sex toys delivery across Gujarat. Buy toys for men, women & couples online."
      />

      {/* 🟢 LOCAL SEO */}
      <meta name="geo.region" content="IN-GJ" />
      <meta name="geo.placename" content="Gujarat" />
      <meta name="geo.position" content="22.2587;71.1924" />
      <meta name="ICBM" content="22.2587, 71.1924" />

      {/* 🟢 SCHEMA – LOCAL BUSINESS */}
      <script type="application/ld+json">
        {`
        {
          "@context": "https://schema.org",
          "@type": "Store",
          "name": "LushDesire Gujarat",
          "url": "https://lushdesire.in/sex-toys-in-gujarat",
          "logo": "https://lushdesire.in/logo.png",
          "description": "Buy sex toys online in Gujarat with discreet packaging. Trusted adult store delivering across Gujarat.",
          "areaServed": {
            "@type": "State",
            "name": "Gujarat"
          },
          "address": {
            "@type": "PostalAddress",
            "addressRegion": "Gujarat",
            "addressCountry": "IN"
          },
          "sameAs": [
            "https://www.facebook.com/lushdesire",
            "https://www.instagram.com/lushdesire"
          ]
        }
        `}
      </script>
    </Helmet>
  );
};

export default GujaratSEO;
